import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Header = styled.div`
    display: flex;
    margin-bottom: 1rem;
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const SelectModelText = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-top: 20px;
`;

export const SelectModelDropdown = styled.div`
    margin-top: 12px;
`;
